import { styled, Box, makeStyles, createStyles, Theme, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const useStyles = makeStyles((theme) =>
  createStyles({
    tabHeader: {
      // minHeight: '70px',
      marginTop: 10,
      maxWidth: '100%',

      '& .MuiTab-root': {
        // minWidth: 'unset',
        padding: '6px 20px',
      },
      '& .MuiTabs-indicator': {
        backgroundColor: COLORS.PRIMARY,
      },

      '& .MuiTabs-scrollButtons.Mui-disabled': {
        opacity: 0.3,
      },

      '& .MuiTab-labelIcon': {
        minHeight: 'unset',
      },
      '& .MuiTab-labelIcon .MuiTab-wrapper > *:first-child': {
        margin: 0,
      },
    },
    tabHeaderLabel: {
      display: 'flex',
    },
  }),
);

export const MainCont = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? '#151a21' : '#edf1f6',
}));

export const Badge = styled(Box)<Theme, { disabled: boolean }>(({ theme, disabled }) => ({
  background: disabled ? (theme.palette.type === 'dark' ? COLORS.GRAY : COLORS.WHITE) : COLORS.ERROR,
  width: 30,
  height: 30,
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginLeft: 20,
  color: disabled ? (theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK) : COLORS.WHITE,
}));

export const NoData = styled(Typography)(({ theme }) => ({
  fontSize: 20,
  color: theme.palette.type === 'dark' ? '#98a1ac' : COLORS.GRAY,
  textAlign: 'center',
  marginTop: 30,
}));
